import { getToolbarConfigWithoutIntents } from '../../core/components/toolbar/utils/get-toolbar-config-without-intents.js';
import type { PieDonutConfig } from '../types/pie-chart.config.js';

export const sanitizeToolbarIntents = (
  config: PieDonutConfig,
): PieDonutConfig => {
  const toolbar = config.toolbar
    ? getToolbarConfigWithoutIntents(config.toolbar)
    : undefined;

  return {
    ...config,
    toolbar,
  };
};
